var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('Tabs',{attrs:{"datas":_vm.tabDatas,"class-name":"h-tabs-card"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_c(_vm.selected,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }